import React, {
  useEffect,
  useImperativeHandle,
  useReducer,
  useState,
} from 'react';
import Iframe from '@/components/onetrust/Iframe';
import { sanitizeUrl } from '@/core';
import { updateParams } from '@/core/url/url.service';
import { VideoSlideRef } from '../video-slide.interface';

interface Prop {
  url: string;
  autoPlay?: boolean;
}

const YoutubeSlide = React.forwardRef<VideoSlideRef, Prop>(
  ({ url, autoPlay = false }, ref) => {
    const [embeddedYoutubeUrl, setEmbeddedYoutubeUrl] = useState('');
    const [updateState, forceUpdate] = useReducer((x) => x + 1, 0);
    useImperativeHandle<any, VideoSlideRef>(ref, () => ({
      forceUpdate,
    }));

    useEffect(() => {
      setURL();
    }, [url]);

    const setURL = () => {
      const t = transformUrl(url);
      if (!t) return;
      const d = disableUnrelatedVideos(t);
      setEmbeddedYoutubeUrl(d);
    };

    const transformUrl = (url: string): string | undefined => {
      try {
        const embeddedUrl = url
          .replace(/watch\?v=/i, 'embed/')
          .replace(/youtu\.be/i, 'www.youtube.com/embed');
        if (!autoPlay) {
          return embeddedUrl;
        }
        return updateParams(url, { autoplay: 1 });
      } catch (e) {
        return undefined;
      }
    };

    const disableUnrelatedVideos = (url: string): string => {
      return updateParams(url, { rel: 0 });
    };

    return (
      <Iframe
        key={updateState}
        className="youtube-player optanon-category-C0004"
        width="100%"
        height="100%"
        style={{ border: 'none' }}
        allow="autoplay"
        allowFullScreen
        src={sanitizeUrl(embeddedYoutubeUrl)}
        data-test-automation-id={'video-slide-item'}
        title={`youtube video - ${url}`}
      />
    );
  },
);

export default YoutubeSlide;
